export const basePath = document.getElementsByTagName("base")[0]?.getAttribute("href") ?? "/";

export function withBase(path: string): string {
    if (path.startsWith("/") || basePath.endsWith("/")) {
        return `${basePath}${path}`.replace(/\/\/+/g, "/")
    } else {
        return `${basePath}/${path}`.replace(/\/\/+/g, "/")
    }
}